import React, { Component } from 'react'

// redux
import { connect } from 'react-redux'
import objectActions from '../../redux/component_select_object/actions'

// lib
import classnames from 'classnames'
import { Row } from 'antd'

// sub component
import ObjectComponent from './object_component'

class ListObject extends Component {
    render() {
        let { objects } = this.props
        return (
            <Row className={classnames('ListObject')}>
                {objects.map((object, index) => {
                    return (
                        <ObjectComponent
                            object={object}
                            key={index}
                            index={index}
                        />
                    )
                })}
                {this.props.objects === 0 && <text>Không có dữ liệu</text>}

            </Row>
        )
    }
}

const mapStateToProps = state => {
    return {
        objects: state.component_select_object.objects,
    }
}

const mapDispatchToProps = dispatch => {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(ListObject)
